// Straight-leg flight geometry used by conflict prediction. Pure functions.

import { PREDICT_SAMPLES } from '../config/constants.js';

export function dist(a, b) {
  return Math.hypot(a.x - b.x, a.y - b.y);
}

/**
 * Position along a leg at time `t`, flown at constant speed between
 * `departAt` and `arriveAt` (clamped to the endpoints outside that window).
 */
export function posAtTime(leg, t) {
  const span = leg.arriveAt - leg.departAt;
  let frac = span > 0 ? (t - leg.departAt) / span : 0;
  frac = Math.max(0, Math.min(1, frac));
  return {
    x: leg.from.x + (leg.to.x - leg.from.x) * frac,
    y: leg.from.y + (leg.to.y - leg.from.y) * frac,
  };
}

/**
 * Closest approach between two legs while both are in the air, sampled over
 * their overlapping time window. Returns null when they're never airborne
 * at the same time.
 */
export function closestApproach(a, b, samples = PREDICT_SAMPLES) {
  const t0 = Math.max(a.departAt, b.departAt);
  const t1 = Math.min(a.arriveAt, b.arriveAt);
  if (t1 <= t0) return null;
  let minD = Infinity;
  let minT = t0;
  for (let i = 0; i <= samples; i++) {
    const t = t0 + (t1 - t0) * i / samples;
    const d = dist(posAtTime(a, t), posAtTime(b, t));
    if (d < minD) { minD = d; minT = t; }
  }
  return { minD, minT };
}
